import { gql } from '@apollo/client'

export const UPDATE_FEEDBACKS_MUTATION = gql`
  mutation updateFeedbacks($ids: [ID!]!, $attributes: FeedbackInput!) {
    updateFeedbacks(ids: $ids, attributes: $attributes)
  }
`
